var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',[_c('h1',[_vm._v("ManagerFormCreateTemplate")])])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }